import {Clusterer} from '@pbe/react-yandex-maps';
import {get, isEqual, round, toNumber} from 'lodash';
import {ReactNode} from 'react';
import {IServiceRequest} from '../../../../../../shared/types/serviceRequest.types';
import {STATUS_LABELS} from '../../constants/status';
import {getRequestCircleStatus} from '../../helpers';
import {formatWorkersFio} from '../../../../../../shared/helpers/formatWorkersFio';

export interface MapPoint {
  requestNumber: string;
  coordinates: [number, number];
  companyName: string;
  contractNumber: string;
  status: string;
  id: string;
  color: string;
  workers: string;
}

export const getPreparePoints = () => {
  // для кэширования
  const points: MapPoint[] = [];
  let prevRequests: IServiceRequest[] = [];

  return (requests: IServiceRequest[]): MapPoint[] => {
    if (isEqual(prevRequests, requests)) {
      return points;
    }

    requests?.forEach((r) => {
      const address = get(r, 'address', {});
      const lon = toNumber(get(address, 'longitude', 0));
      const lat = toNumber(get(address, 'latitude', 0));
      const archived = Boolean(get(r, 'archived', false));
      const {color} = archived
        ? {color: '#A8ACB0'}
        : getRequestCircleStatus(r, {
            getStatus: (r) => get(r, 'plannedDate'),
            getPlannedDate: (r) => get(r, 'plannedDate'),
          });

      points.push({
        requestNumber: get(r, 'extNumber', ''),
        coordinates: [lat, lon],
        companyName: get(r, 'companyName', ''),
        contractNumber: get(r, 'contract.contractNumber', ''),
        status: get(r, 'statusCode', ''),
        id: get(r, 'id', '').toString(),
        color,
        workers: formatWorkersFio(r.workers),
      });
    });

    prevRequests = requests;
    return points;
  };
};

export const renderClusterer = (key: number | string, show: boolean, renderFn: () => ReactNode) => {
  const children = renderFn();

  if (show) {
    return (
      <Clusterer options={{preset: 'islands#violetClusterIcons'}} key={key}>
        {children}
      </Clusterer>
    );
  }
  return children;
};

export const prepareMapWidth = (parent: HTMLDivElement | null) => {
  if (!parent) {
    return '100%';
  }

  const computedStyle = window.getComputedStyle(parent);
  const paddingLeft = parseInt(computedStyle.paddingLeft, 10);
  const paddingRight = parseInt(computedStyle.paddingRight, 10);
  const {width} = parent.getBoundingClientRect();
  const adjustedWidth = round(width - paddingLeft - paddingRight, 0);

  return `${adjustedWidth}px`;
};

export const getBalloonContent = (point: MapPoint) => {
  return `
    <div style='display: flex; flex-direction: column;'>
        <span>
            <b>Наименование компании:</b>
            ${point.companyName}
        </span>
        <span style="margin-top: 8px;">
            <b>Номер контракта:</b>
            ${point.contractNumber}
        </span>
        <span>
            <b>Номер заявки:</b>
            ${point.id}
        </span>
        <span>
            <b>ФИО ответственного:</b>
            ${point.workers || '-'}
        </span>
        <span>
            <b>Статус:</b>
            ${get(STATUS_LABELS, point.status, '')}
        </span>
        <a id="button-${point.id}" href="/serviceRequests/${point.id}" style="margin-top: 10px; padding: 0; width: fit-content; cursor: pointer; color: #0D99FF; text-underline-offset: 3px;">
            Перейти к заявке
        </a>
    </div>
  `;
};

export const getRedirectButton = (requestNumber?: string) => {
  if (!requestNumber) return null;
  return document.getElementById(`button-${requestNumber}`);
};

export const renderMapPoint = (point: MapPoint) => {
  return encodeURIComponent(`
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11" fill="white" stroke="${point.color}" stroke-width="2"/>
        <ellipse cx="12.0001" cy="11.9999" rx="9.23077" ry="9.12" fill="${point.color}"/>
    </svg>
  `);
};
